import ArrowSvg from '../../assets/icons/arrow-left.svg';

export const StepNav = ({ isFirst, isLast, onBack, onNext }) => (
  <div className="stepper-actions">
    <button
      type="button"
      className="stepper-btn stepper-btn-back"
      aria-label="Назад"
      disabled={isFirst}
      onClick={onBack}
    >
      <img src={ArrowSvg} alt="" width="20" height="20" />
    </button>

    <button
      type="button"
      className={`stepper-btn stepper-btn-next ${isLast ? 'finish' : ''}`}
      onClick={onNext}
    >
      {isLast ? 'Готово' : 'Далее'}
    </button>
  </div>
);
